<template>
  <div class="container">

    <div class="main">
      <div class="title">
        <p>患者列表</p>
        <el-select v-model="patientType" class="patient-type">
          <el-option v-for="item in patientTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="card" id="table_card">
        <div class="row1">
          <div class="search">
            <input type="text" v-model="searchWord" placeholder="请输入姓名、床号或科室" @keyup="startSearch" />
            <img src="/static/report/icon_search.png" />
          </div>
        </div>

        <div class="table_wrap">
          <table>
            <tr class="header">
              <td width="19%">姓名</td>
              <td width="15%">科室</td>
              <td width="19%">手机号</td>
              <td width="15%">住院号/门诊号</td>
              <td width="15%">床号</td>
              <td width="15%">操作</td>
            </tr>
            <!--          </table>-->
            <!--          <table>-->
            <tr v-for="(item, index) in patientList" class="content" :class="{'gray':!(index%2)}">
              <td width="19%" v-html="item.name"></td>
              <td width="15%" v-html="item.department"></td>
              <td width="19%" v-html="item.mobile"></td>
              <td width="15%">{{item.admit}}</td>
              <td width="15%" v-html="item.bed"></td>
              <td width="15%" class="op" @click="viewReportPrepare(index)">查看</td>
            </tr>
          </table>

        </div>

        <div class="page_row">
          <el-button @click="prevPage()">上一页
          </el-button>
          <span>{{pageInfo.curIndex+1}}/{{pageInfo.pageNum}}</span>
          <el-button @click="nextPage()">下一页
          </el-button>
        </div>
      </div>
    </div>

    <!-- <ReportFooter /> -->
  </div>
  <!--container结束-->
</template>

<script>
// import echarts from 'echarts'
import auth from '../auth/auth'
// import ReportFooter from './ReportFooter'
export default {
  components: {
    //  ReportFooter
  },
  data () {
    return {
      patientList: [{
        'name': '张三',
        'mobile': '12345678911',
        'dept': '内分泌',
        'cureNo': '1123151'
      }],

      patientList: [],
      total: [],
      saveTotal: [],
      pageInfo: {
        curIndex: 0,
        pageNum: 0
      },
      perPage: 8,
      searchWord: sessionStorage.getItem('WeitanHosReportInput')||'', 
      patientType:Number(sessionStorage.getItem('weitanHosPatientType'))||0,
      patientTypeList: [
        {
          value: 0,
          label: '所有'
        },
        {
          value: 1,
          label: '住院中'
        },
        {
          value: 2,
          label: '已出院'
        },
        {
          value: 3,
          label: '回收站'
        }
      ],
      rawPatientData: '',
      searchWord:sessionStorage.getItem('WeitanHosReportInput')||'',
    }
  },
  computed: {
  },
  watch: {
    patientType (val, oldval) {
      let changeList = [0, 3]
      sessionStorage.setItem('weitanHosPatientType',val)
      if (changeList.includes(val) || changeList.includes(oldval)) {
        this.getList()
      } else {
        this.filterTotal()
      }
    }
  },
  mounted () {
    let req = this.getRequest()
    this.cureNo = req.cureNo;
    this.getList()
  },
  methods: {
    filterTotal () {
      
      this.total = this.rawPatientData.filter(item => {
        if ((this.patientType === 2 && item.state !== 'out') || (this.patientType === 1 && item.state !== 'in')) {
          return false
        }
        return item
      }).map(e => {
        return {
          name: e.patient_info.name,
          mobile: e.mobile_number,
          department: e.department,
          admit: e.patient_info.admit,
          id: e.id,
          bed:e.patient_info.bed,
          patient_info: e.patient_info
        }
      })
      this.saveTotal = this.total;
      let size = this.saveTotal.length;
      let pageNum = Math.ceil(size / this.perPage);
      if(pageNum === 0) pageNum = 1
      this.pageInfo.pageNum = pageNum;
      this.pageInfo.curIndex = Number(sessionStorage.getItem('weitanHosCurIndex'))||0
      this.updatePage(this.pageInfo.curIndex);
    },
    getList () {
      let param = {
        get_delete_flag: this.patientType === 3
      }
      if (this.patientType === 0) {
        param = {
          get_all_flag: true
        }
      }
      this.$http.post('/api/v2.1/center/patient/get_list', param).then(res => {
        if (0 == res.data.error) {
          this.rawPatientData = res.data.patient.reverse();
          this.filterTotal()
        }
      }, function (err) {

      })
    },
    startSearch () {
     
      this.updatePage(0);

    },

    prevPage () {
      if (this.pageInfo.curIndex > 0) {
        this.updatePage(this.pageInfo.curIndex - 1);
      }
    },
    nextPage () {
      if (this.pageInfo.curIndex < (this.pageInfo.pageNum - 1)) {
        this.updatePage(this.pageInfo.curIndex + 1);
      }
    },
    updatePage (pageIndex) {
      sessionStorage.setItem('weitanHosCurIndex',0)
      if (!this.searchWord) {
        this.total = this.saveTotal;
        this.pageInfo.pageNum = Math.ceil(this.total.length / this.perPage);
      }else{
        let searchTotal = [];
        for (let i = 0; i < this.saveTotal.length; i++) {
          let item = this.saveTotal[i];
          let copyItem = { ...item };
          let name = item.name || '';
          let mobile = item.mobile || '';
          let dept = item.department || '';
          let bed = item.bed || '';
          //
          if (name.indexOf(this.searchWord) >= 0 || mobile.indexOf(this.searchWord) >= 0 ||
            dept.indexOf(this.searchWord) >= 0||bed.indexOf(this.searchWord) >= 0) {

            copyItem.name = name.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>')
            copyItem.mobile = mobile.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>')
            copyItem.department = dept.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>')
            copyItem.bed = bed.replace(this.searchWord, '<span style="color: lightcoral">' + this.searchWord + '</span>')
            searchTotal.push(copyItem)
          }
        }
        this.total = searchTotal;
      }
      sessionStorage.setItem('WeitanHosReportInput',this.searchWord)
      this.pageInfo.pageNum = Math.ceil(this.total.length / this.perPage);


      let size = this.total.length;
      let curIndex = pageIndex;
      let perPage = this.perPage;
      this.pageInfo.curIndex = curIndex;


      let patientList = [];
      for (let i = 0; i < perPage; i++) {
        let pos = curIndex * perPage + i;
        if (pos >= size) {
          break;
        }
        let item = this.total[pos];
        let patientInfo = {};
        patientInfo.name = item.name;
        patientInfo.mobile = item.mobile;
        patientInfo.department = item.department;
        patientInfo.admit = item.admit;
        patientInfo.uid = item.id;
        patientInfo.bed = item.bed;
        patientInfo.patient_info = item.patient_info;
        patientList.push(patientInfo)
      }
      this.patientList = patientList;
    },
    onBtnLogin () {
      console.log("btn login");
    },
    viewReportPrepare (index) {
      let patientInfo = this.patientList[index];
      let selecter = '#table_card > div.table_wrap > table > tr:nth-child(' + (index+2) + ') > td:nth-child('
      let filterList = ['name', 'department', 'mobile']
      filterList.map((item, i) => {
        if (this.patientList[index][item]&&this.patientList[index][item].match(/<.+>/g)) {
          patientInfo[item] = document.querySelector(selecter + (i+1) + ')').innerText
        }
      })
      this.$store.commit('updatePatientPage', this.pageInfo.curIndex)
      sessionStorage.setItem('ReportPatientInfo', JSON.stringify(patientInfo));
      sessionStorage.setItem('weitanHosCurIndex',this.pageInfo.curIndex)
      this.$router.push('/reportPrepare');
    },
    getRequest () {

      let href = location.href;
      let theRequest = {};
      if (href.indexOf("?") != -1) {
        let search = href.substring(href.indexOf("?") + 1)
        // var str = url.substr(1);
        let strs = search.split("&");
        for (let i = 0; i < strs.length; i++) {
          let pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }

      }
      return theRequest;
    },

  },
}
</script>

<style scoped>
p,
body,
html {
  margin: 0;
}

.container {
  min-height: 800px;
  background-color: #f4f4f4;
}

.container .main {
  width: 1200px;
  margin: 0 auto;
}

.container .main .title {
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #000000;
  font-size: 26px;
  padding-top: 30px;
  padding-left: 50px;
  display: flex;
  flex-direction: row;
}
.patient-type {
  margin-left: 20px;
}
.container .main .card {
  margin-top: 15px;
  width: 100%;
  height: 750px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
}

#table_card .row1 {
  padding-top: 30px;
  padding-left: 40px;
  height: 80px;
  border-bottom: solid 1px #707070;
}

#table_card .row1 .text {
  font-size: 24px;
  float: left;
}

#table_card .row1 .sel {
  width: 180px;
  height: 32px;
  font-size: 20px;
  float: left;
  margin-left: 15px;
}

#table_card .search {
  width: 280px;
  height: 40px;
  background-color: #ffffff;
  border: 1px solid;
  border-color: #999999;
  border-radius: 20px;
  float: right;
  margin-right: 40px;
  padding-left: 20px;
}

#table_card .search img {
  float: right;
  margin-top: 8px;
  margin-right: 20px;
}

#table_card .search input {
  margin-top: 4px;
  height: 30px;
  width: 220px;
  font-size: 18px;
  padding-left: 10px;
  outline: none;
  border: none;
}

#table_card .table_wrap {
  height: 550px;
}

#table_card .page_row {
  padding-left: 30px;
}

#table_card .table_wrap table {
  width: 96%;
  margin: 0 auto;
  margin-top: 30px;
  border-collapse: collapse;
}

#table_card .table_wrap table .header {
  font-size: 20px;
  font-weight: 500;
  height: 50px;
}

#table_card .table_wrap table tr:nth-child(n + 2) {
  height: 50px;
  font-size: 18px;
}

#table_card .table_wrap table .gray {
  background-color: #eaeaea;
}

#table_card .table_wrap table .content {
  font-size: 18px;
}

#table_card .table_wrap table td {
  text-align: center;
}

#table_card .table_wrap table .op {
  color: #ff6f00;
  cursor: pointer;
}

.footer {
  height: 21px;
  width: 80%;
  margin: 8.5% auto 0;
  font-size: 18px;
  color: rgba(246, 248, 251, 0.9);
  letter-spacing: -0.54px;
  text-align: center;
  font-family: SFUIText-Regular;
}
.footer a {
  color: rgba(246, 248, 251, 0.9);
  text-decoration: none;
}
.footer a:hover {
  color: #0090d3;
}
@media screen and (max-width: 1500px) {
  .footer {
    margin: 6.5% auto 0;
  }
}

@media print {
}
/deep/ .el-select-dropdown__item.selected.hover {
  background-color: #eaeaea;
}
/deep/ .el-select-dropdown__item.selected {
  color: #000000;
  background-color: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// ReportList.vue?266dc1fa